<script lang="ts">
  import Page from '$components/page/Page.svelte';
  import Button from '$components/button/Button.svelte';
  import Image from '$lib/assets/safe-migration-header.webp';
  import { goToTransition } from '$utils/goToTransition';

  const logOut = () => {
    window.localStorage.clear();
    window.sessionStorage.clear();
    goToTransition('left', '/migrate-domain');
  };
</script>

<Page>
  {#snippet middle()}
    <div class="h-[370px]">
      <img src={Image} alt="Metri" class="h-full w-full object-cover" />
    </div>
    <div class="p-gno-page">
      <h3 class="typography-l-semibold">You are already on Safe 1.4.1 version</h3>
      <div class="text-brand">
        <p class="my-4">
          The passkey you chose to migrate is inactive. <span class="typography-l-semibold"
            >Meaning you already migrated to Safe 1.4.1 using another passkey.
          </span>
          Please login with the other passkey.
        </p>
      </div>
    </div>
  {/snippet}
  {#snippet bottom()}
    <div class="grid gap-3 p-gno-page">
      <Button ariaLabel="Log Out" variant="plain" onclick={logOut}>Log Out</Button>
    </div>
  {/snippet}
</Page>
